import actions from '@/vuex/modules/ui/drawerToggleButton/actions'
import getters from '@/vuex/modules/ui/drawerToggleButton/getters'
import mutations from '@/vuex/modules/ui/drawerToggleButton/mutations'

const namespaced = true

const state = {
  isVisible: false,
}

/*
 * メニュー情報を保持するmodule
 */
const drawerToggleButton = {
  state: state,
  namespaced: namespaced,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default drawerToggleButton
